import React, { Fragment, Component } from "react";
/**
 * Assets
 */
import "../Styles/Navbar.scss";

class Navbar extends Component {
  render() {
    return (
      <Fragment>
        <nav></nav>
      </Fragment>
    );
  }
}

export default Navbar;
